import styled from 'styled-components';

interface ContainerProps {
    isSelected: boolean;
    backgroundColor: string;
}

export const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    width: 220px;
    ${({ backgroundColor }) => backgroundColor && `
    background: ${backgroundColor};
    `}
    border-radius: 9px;

    ${({ isSelected }) => isSelected && `
    border-width: 3px;
    border-color: white;
    border-style: solid;
    
    -webkit-box-shadow: 5px 5px 15px -3px rgba(114,114,114,0.55); 
    box-shadow: 5px 5px 15px -3px rgba(114,114,114,0.55);
  `}
}
`;

export const Content = styled.div`
    padding: 10px;
    color: white;
    font-weight: 500;
    min-height: 50px;
    line-height: 15px;
    font-size: 13px;
}
`;
